module.exports = __webpack_public_path__ + "img/small-pass.0684cb7d.png";